

// var urls = function(){
//   var REBATE_INIT = "ac=init";
// }

// export default {    
//   istest(){
//       console.log("this is test")
//   },
//   init(){
//     return "ac=init";
//   }
// }

var urls = {
  sendAppointmentSms: 'common/cross_index.php?ct=external&ac=sendAppointmentSms',// 预约用户发送手机验证码
  appointment: 'common/cross_index.php?ct=external&ac=appointment',// 用户预约接口
  appointmentNum: 'common/cross_index.php?ct=external&ac=appointmentNum',// 页面预约人数接口
  
}
export default urls


// WEBPACK FOOTER //
// ./src/network/urls.js